export default function isSvgUrl(url) {
  return !!url.match(/\.svg$/i);
}